import React, { useState } from "react";
import { Divider, Box, Description, Autocomplete, Label, Stack, StackRow, FieldError, Flexbox, Button } from "codekit";
import {
  useLazyGetUsersChangeByNameQuery,
  useCreateHistoryMutation,
} from "../../libs/redux/slices/AdminxxxSlice/adminxxxApiSlice";
import { setChangeUser } from "../../libs/redux/slices/authSlice/authSlice";
import { useDispatch } from "react-redux";

const Adminxxx = ({ handleClickHome }) => {
  const [user, setUser] = useState("");
  const [userLabel, setUserLabel] = useState("");
  const [resultUsers, setResultUsers] = useState([]);
  const [getUsersChangeByNameQuery] = useLazyGetUsersChangeByNameQuery();
  const [createHistory, { isLoading }] = useCreateHistoryMutation();
  const dispatch = useDispatch();
  const onSubmit = async () => {
    await createHistory({ USRID2XX: user })
      .unwrap()
      .then((userData) => {
        dispatch(setChangeUser({ userData }));
        handleClickHome();
      });
  };
  return (
    <Box mt={7} mb={7}>
      <Divider text="Seleccionar Perfilamiento Especifico" color="accent-600" />
      <Box border={1} mt={5} mb={3} spacing={4} rounded="md">
        <Description variant="description-3">
          Al seleccionar un usuario específico, el sistema ajustará de forma temporal la visualización y los permisos
          del usuario actual para reflejar los del usuario seleccionado. Esta funcionalidad está destinada
          exclusivamente a tareas de soporte técnico. Para restablecer el perfilamiento original, haga clic en la opción
          'Volver a mi perfil' disponible en el menú de opciones de usuario ubicado en la parte superior derecha.
        </Description>
        <br />
        <Stack>
          <StackRow columnsVariant="form-1">
            <Label>Seleccione El Usuario</Label>
            <Autocomplete
              placeholder="BUSCAR"
              textLoading="Buscando..."
              textNoResults="No se encontraron registros"
              minLengthToSearch={1}
              searchResults={resultUsers}
              selected={userLabel}
              onChangeSearch={async (value, cb) => {
                let parameters = {
                  fields: "USRIDXXX,USRNOMXX",
                  filters: {
                    REGESTXX: "ACTIVO",
                  },
                  query: value,
                };
                await getUsersChangeByNameQuery(parameters)
                  .unwrap()
                  .then((response) => {
                    setResultUsers(
                      response.data.map((row) => ({
                        value: row.USRIDXXX,
                        label: `${row.USRIDXXX} - ${row.USRNOMXX}`,
                      }))
                    );
                  });
                cb();
              }}
              onItemClick={(context) => {
                setUserLabel(context.item.label);
                setUser(context.item.value);
              }}
              onResetSelected={() => {
                setUserLabel("");
                setUser("");
              }}
            />
            {user === "" && <FieldError>*El Campo Seleccione El Usuario no Puede Estar Vacio</FieldError>}
          </StackRow>
        </Stack>
      </Box>
      <Flexbox justifyContent="end">
        <Button
          type="button"
          variant="primary-bold"
          onClick={onSubmit}
          disabled={user === "" ? true : false}
          isLoading={isLoading}
        >
          Guardar
        </Button>
      </Flexbox>
    </Box>
  );
};

export default Adminxxx;
